module.exports = __webpack_public_path__ + "media/images/dashboards/omitted-8065735f914f3556e7b061f77ebe2a05.png";